import { Component, input } from '@angular/core';

@Component({
  selector: 'link-taskbar',
  templateUrl: './link-taskbar.component.html',
  styleUrl: './link-taskbar.component.scss'
})
export class LinkTaskbarComponent {
  settings = input.required<LinkTaskbarSettings>();
  
  navigateToMapDwelling(): void {}
}

export interface LinkTaskbarSettings {
  showViewInMap?: boolean;
  showGetCadastreReport?: boolean;
  showGetLandRegistrationReport?: boolean;
}
